// Campus photo for /colleges/columbia-university: CC BY 2.0, by Ajay Suresh from New York, NY, USA, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AColumbia_University_-_Low_Memorial_Library_(48170370506).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/columbia-university/; credited under the photo.
const photo = {
    "slug": "columbia-university",
    "alt": "Low Memorial Library, with the Alma Mater statue on its steps, at Columbia University in New York City",
    "src": "/colleges/columbia-university/campus-1600.webp",
    "srcSmall": "/colleges/columbia-university/campus-800.webp",
    "srcMid": "/colleges/columbia-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/columbia-university/og.jpg",
    "title": "Columbia University - Low Memorial Library (48170370506)",
    "author": "Ajay Suresh from New York, NY, USA",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AColumbia_University_-_Low_Memorial_Library_(48170370506).jpg",
    "read": "2026-10-01"
};

export default photo;
